import { render } from "./ThreadComponent.vue?vue&type=template&id=773ce75e"
import script from "./ThreadComponent.vue?vue&type=script&lang=js"
export * from "./ThreadComponent.vue?vue&type=script&lang=js"
script.render = render

export default script